import { TaskPriorityUnionType } from '@api';
import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentPropsWithoutRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getTaskPriorityPresentation } from '../../../../utils';
import { TaskFormSchemaType } from '../../hooks';
import { PriorityOption } from './components';

type PrioritySelectPropsType = Omit<
  ComponentPropsWithoutRef<typeof SelectField<TaskFormSchemaType>>,
  'fieldName' | 'data' | 'renderOption'
>;

export const PrioritySelect: React.FC<PrioritySelectPropsType> = (props) => {
  const { t } = useTranslation('tasks');
  const { watch } = useFormContext<TaskFormSchemaType>();
  const priority = watch('priority');

  const priorityOptions = [
    { value: 'HIGH', label: t('PRIORITY.HIGH') },
    { value: 'MEDIUM', label: t('PRIORITY.MEDIUM') },
    { value: 'LOW', label: t('PRIORITY.LOW') },
    { value: 'INFORMATIVE', label: t('PRIORITY.INFORMATIVE') },
  ];

  const selectedPresentation = priority
    ? getTaskPriorityPresentation(priority)
    : null;

  return (
    <SelectField<TaskFormSchemaType>
      fieldName="priority"
      data={priorityOptions}
      leftSection={
        selectedPresentation ? (
          <FontAwesomeIcon
            icon={selectedPresentation.icon}
            size="xs"
            color={selectedPresentation.color}
          />
        ) : undefined
      }
      leftSectionPointerEvents="none"
      renderOption={(item) => (
        <PriorityOption
          priority={item.option.value as TaskPriorityUnionType}
          label={item.option.label}
        />
      )}
      {...props}
    />
  );
};
